import { createEventDefinition } from 'ts-bus';

export const EVENT_UPGRADE_REQUEST_SENT = 'EVENT_UPGRADE_REQUEST_SENT';

export const upgradeRequestSent = createEventDefinition()(EVENT_UPGRADE_REQUEST_SENT);
